import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { ProductDependenciesContext, useHubContext } from '@atlassian/company-hub-common';
import { AiSearchTriggerFloatingWithContext, AiSearchTriggerWithContext, CustomizeAIMessage, useOptionalAiWidgetConfig } from '@atlassian/csm-ai-search-trigger';
import { SearchTrigger } from '@atlassian/csm-widget-ui-components/search-trigger';
export var CommonHubExtensionsDependenciesProvider = function CommonHubExtensionsDependenciesProvider(_ref) {
  var children = _ref.children;
  var _useHubContext = useHubContext(),
    cloudId = _useHubContext.cloudId,
    pageMediaConfig = _useHubContext.pageMediaConfig,
    hubMediaConfig = _useHubContext.hubMediaConfig,
    env = _useHubContext.env;
  var widgetConfigContext = useOptionalAiWidgetConfig();
  var showAIAgent = Boolean(widgetConfigContext && widgetConfigContext.supportWidgetConfig.widgetPosition === 'CENTER');
  var authProvider = useCallback(function () {
    return Promise.resolve({
      asapIssuer: pageMediaConfig.asapIssuer,
      token: pageMediaConfig.mediaToken,
      baseUrl: pageMediaConfig.mediaUrl
    });
  }, [pageMediaConfig]);
  var createEditorMediaProvider = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var onUploadRejection, mediaProvider;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onUploadRejection = _ref2.onUploadRejection;
            mediaProvider = {
              uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
              },
              viewMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
              },
              uploadMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
              }
            };
            return _context.abrupt("return", mediaProvider);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [authProvider, pageMediaConfig]);
  var createRendererMediaProvider = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var mediaProvider;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          mediaProvider = {
            uploadParams: {
              collection: pageMediaConfig.mediaCollectionName
            },
            viewMediaClientConfig: {
              authProvider: authProvider,
              useSha256ForUploads: true
            }
          };
          return _context2.abrupt("return", mediaProvider);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [authProvider, pageMediaConfig]);
  var contextValue = {
    smartCardProviderComponent: undefined,
    isTargetAudience: function isTargetAudience() {
      return false;
    },
    useSegmentationTargetGroups: function useSegmentationTargetGroups() {
      return {};
    },
    isCompanyHub: true,
    // need to pass this true to enable company hub specific extensions
    cloudId: cloudId,
    helpCenterAri: env.helpCenterAri,
    isAdminHubAIEnabled: false,
    linkPickerConfig: {
      linkPickerPlugins: []
    },
    userId: '',
    customMediaConfig: hubMediaConfig,
    agent: showAIAgent ? {
      agentComponent: AiSearchTriggerWithContext,
      floatingComponent: AiSearchTriggerFloatingWithContext,
      agentPreviewComponent: function agentPreviewComponent() {
        return /*#__PURE__*/React.createElement(SearchTrigger, {
          placeholder: "Preview",
          submitButton: /*#__PURE__*/React.createElement("div", null)
        });
      }
    } : undefined,
    ConfigPanelCustomMessageContent: showAIAgent ? CustomizeAIMessage : undefined,
    createEditorMediaProvider: createEditorMediaProvider,
    createRendererMediaProvider: createRendererMediaProvider
  };
  return /*#__PURE__*/React.createElement(ProductDependenciesContext.Provider, {
    value: contextValue
  }, children);
};